<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-4 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-8 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteMany()"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              v-if="canUserCreate"
              type="primary"
              @click="$router.push('/partners/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Partner</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-employees"></i>
                    <strong>Partner Type</strong>
                  </base-button>

                  <div
                    class="dropdown-item"
                    :class="partnerType === 'all' ? 'active' : ''"
                    @click="typeSearch('all')"
                  >
                    All
                  </div>
                  <div
                    class="dropdown-item"
                    :class="partnerType === 'travel_agency' ? 'active' : ''"
                    @click="typeSearch('travel_agency')"
                  >
                    Travel Agency
                  </div>
                  <div
                    class="dropdown-item"
                    :class="partnerType === 'travel_access' ? 'active' : ''"
                    @click="typeSearch('travel_access')"
                  >
                    Agent
                  </div>
                </base-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-3 col-lg-4 col-md-5 col-sm-5 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows"
              >
                <b-form-radio value="all">All</b-form-radio>

                <b-form-radio value="toapproved"
                  >Pending Approval<badge
                    type="danger square"
                    v-if="approval > 0"
                    >{{ approval }}</badge
                  ></b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right mb-1"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 col-sm-6 ml-auto d-inline-block"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-2"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    :aria-describedby="ariaDescribedby"
                    @change="applySortBy"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>
            <div class="d-inline-block mr-2 mb-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>
            <div v-if="canUserExport" class="d-inline-block mr-2 mb-2">
              <el-tooltip content="Export" placement="bottom">
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="div"
                  title-tag="a"
                  title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                  title="Export"
                >
                  <base-button
                    slot="title"
                    type="none"
                    class="pl-0 pr-0 icon-only"
                  >
                    <i class="flaticon-downloading-files mr-0 "></i>
                  </base-button>

                  <div
                    class="dropdown-item"
                    @click="download(selectedRows)"
                    v-if="selectedRows.length > 0"
                  >
                    Selected Records
                  </div>
                  <div class="dropdown-item" @click="download([])">
                    All Records
                  </div>
                </base-dropdown>
              </el-tooltip>
            </div>
            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <div>
          <pagination-block
            :pageCount="partners.pages"
            :total="partners.count"
            v-model="currentPage"
            :limit="limit"
            @changeLimit="changeLimit"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="previousPaginations"
            position="bottom"
          ></pagination-block>

          <b-table
            hover
            :items="items"
            :fields="fields"
            sort-by.sync="created_at"
            sort-asc.sync="true"
            selectable
            @row-selected="onRowSelected"
            select-mode="multi"
            ref="selectableTable"
            sort-icon-left
            responsive
            show-empty
            empty-filtered-text="There are no records matching your request"
            empty-text="There are no records to show"
            :stacked="cardview"
          >
            <template #head()="{ label, field: { key } }">
              <span v-if="key === 'selected'">
                <span
                  @click="clearSelected"
                  v-if="selectedRows.length == items.length"
                  class="check-table selected"
                ></span>

                <span @click="selectAllRows" v-else class="check-table"></span>
              </span>
              <span v-else>{{ label }}</span>
            </template>
            <template #cell(selected)="{ rowSelected }">
              <template v-if="rowSelected">
                <span aria-hidden="true" class="check-table selected"></span>
                <span class="sr-only">Selected</span>
              </template>
              <template v-else>
                <span aria-hidden="true" class="check-table"></span>
                <span class="sr-only">Not selected</span>
              </template>
            </template>

            <template #thead-top=""> </template>

            <template #cell(first_name)="data">
              <div class="d-flex align-items-center link-img-profile">
                <div
                  v-if="data.item.url_picture"
                  class="img-user-list mr-2"
                  v-bind:style="{
                    backgroundImage: `url('${data.item.url_picture}')`
                  }"
                ></div>

                <div
                  v-else
                  class="img-user-list mr-2"
                  v-bind:style="{
                    backgroundImage: 'url(' + imageProfile + ')'
                  }"
                ></div>
                <div class="d-inline-flex">
                  <div v-if="'travel_agency' === data.item.type">
                    <span class="role-table capitalize">
                      {{ data.item.first_name }} {{ data.item.last_name }}
                    </span>
                    <router-link
                      class="capitalize hide-data"
                      :to="`/partners/${data.item._id}`"
                      >{{ data.item.company_name }}</router-link
                    >
                  </div>
                  <div v-else>
                    <span
                      class="role-table capitalize"
                      v-if="data.item.association"
                    >
                      {{ data.item.association.company_name }}
                    </span>
                    <router-link
                      class="capitalize hide-data"
                      :to="`/partners/${data.item._id}`"
                      >{{ data.item.first_name }}
                      {{ data.item.last_name }}</router-link
                    >
                  </div>
                </div>

                <div class="d-inline-flex">
                  <el-tooltip
                    content="Confirmed"
                    placement="bottom"
                    v-if="data.item.status"
                  >
                    <i
                      class="flaticon-check-2 text-success mt-1  ml-1 f-14"
                    ></i>
                  </el-tooltip>

                  <el-tooltip v-else content="No Confirmed" placement="bottom">
                    <i class="flaticon-check-2 text-danger mt-1 ml-1 f-14"></i>
                  </el-tooltip>
                </div>
              </div>
            </template>

            <template #cell(type)="data">
              <span class="text-capitalize">{{
                data.item.type | typeUser
              }}</span>
            </template>

            <template #cell(gender)="data">
              <span class="capitalize">{{
                data.item.gender | formatGender
              }}</span>
            </template>

            <template #cell(country)="data">
              <span class="capitalize" v-if="data.item.country">{{
                data.item.country
              }}</span>
              <span v-else>--</span>
            </template>

            <template #cell(phone)="data">
              <span class="hide-data capitalize">{{ data.item.phone }}</span>
            </template>

            <template #cell(email)="data">
              <a
                class="hide-data"
                :href="
                  `https://mail.google.com/mail/?view=cm&fs=1&to=${data.item.email}`
                "
                target="_blank"
                >{{ data.item.email }}</a
              >
            </template>

            <template #cell(markup)="data">
              <span>{{ data.item.mark_up }}%</span>
            </template>
            <template #cell(commercialTerms)="data">
              <span class="f-12 d-block">{{
                getCommercialTerms(data.item.type_charge)
              }}</span>
              <span v-if="data.item.type_charge === 'commission'"
                >{{ data.item.commission }}%</span
              >
            </template>

            <template #cell(actions)="data">
              <el-tooltip
                content="History"
                placement="bottom"
                class="d-inline-flex"
              >
                <span
                  class="icon-action text-blue mr-2"
                  @click.stop="openPartnerHistoryModal(data.item._id)"
                >
                  <i class="flaticon-wall-clock-1"> </i>
                </span>
              </el-tooltip>

              <ActionLink
                :basePath="'/partners'"
                :id="data.item._id"
                :canUpdate="canUserUpdate"
                :canRead="canUserRead"
                :linkClass="'icon-action'"
                :iconExtraClass="'text-primary'"
              />

              <el-tooltip
                content="Approval"
                placement="bottom"
                v-if="
                  canUserUpdate &&
                    data.item.type === 'travel_agency' &&
                    !data.item.approve
                "
              >
                <span
                  class="icon-action ml-2"
                  @click.stop="openModalApproval(data.item._id)"
                >
                  <i class="flaticon-bold-check text-success"></i>
                </span>
              </el-tooltip>
              <el-tooltip
                v-if="
                  canUserResendEmail &&
                    !data.item.status &&
                    data.item.type !== 'guest'
                "
                content="Account Confirmation Email"
                placement="bottom"
              >
                <span
                  class="icon-action text-warning ml-2"
                  @click="
                    sendEmailToConfirmAccount(
                      data.item._id,
                      data.item.email,
                      data.item.type
                    )
                  "
                >
                  <i class="flaticon-envelope text-warning"></i>
                </span>
              </el-tooltip>
              <el-tooltip
                v-if="
                  canUserResendEmail &&
                    data.item.status &&
                    data.item.type !== 'guest'
                "
                content="Send password recovery email"
                placement="bottom"
              >
                <span
                  class="icon-action text-warning ml-2"
                  @click="
                    sendEmailToRecoverPassword(
                      data.item._id,
                      data.item.email,
                      data.item.type
                    )
                  "
                >
                  <i class="flaticon-envelope text-warning"></i>
                </span>
              </el-tooltip>

              <el-tooltip content="Delete" placement="bottom">
                <span
                  v-if="canUserDelete"
                  class="icon-action text-danger ml-2"
                  @click="deletePartner(data.item._id)"
                >
                  <i class="flaticon-delete"></i>
                </span>
              </el-tooltip>
            </template>
          </b-table>
          <pagination-block
            :pageCount="partners.pages"
            :total="partners.count"
            :limit="limit"
            @changeLimit="changeLimit"
            v-model="currentPage"
            @changePage="changePage"
            @nextPage="nextPaginations"
            @prevPage="previousPaginations"
            position="bottom"
          ></pagination-block>
        </div>
      </div>
    </div>

    <PartnerApproval
      :show="showApprovalModal"
      :partnerId="partnerId"
      :agencies="agencies"
      @close="closeApprovalModal"
      @partnerApproved="onPartnerApproved"
    />
    <PartnerHistory
      :show="showPartnerHistory"
      :tempPartnerId="tempPartnerId"
      @close="closePartnerHistoryModal"
    />
  </section>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { PartnersAPI, DocumentsAPI } from "../../../core/api";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import WSelect from "@/components/Select";
import PartnerApproval from "../components/PartnerApproval.vue";
import PartnerHistory from "../components/PartnerHistory";
import {
  goBack,
  isUserAuthorized,
  ROLE_HIERARCHY,
  setSigOut
} from "../../../helpers/commons.helpers";
import ActionLink from "../../../components/ActionLink.vue";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "Partners",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    WSelect,
    PartnerApproval: PartnerApproval,
    PartnerHistory: PartnerHistory
  },
  data() {
    return {
      limit: 0,
      currentPage: 1,
      selectedRows: [],
      modal: false,
      pusher: null,
      searchQuery: "",
      query: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center ",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "first_name",
          label: "Partners",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },

        {
          key: "type",
          label: "Type",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "gender",
          label: "Gender",
          sortable: true,
          thStyle: { minWidth: "80px" },
          class: "alinmov6"
        },
        {
          key: "country",
          label: "Country",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "text-left"
        },
        {
          key: "phone",
          label: "Phone N°",
          sortable: true,
          thStyle: { minWidth: "120px" },
          class: "alinmov6"
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },
        {
          key: "markup",
          label: "Markup",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "commercialTerms",
          label: "Terms",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "position-relative alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      selected: [],
      simpleSearch: "",
      sortBy: "",
      sortDesc: "asc",
      sortDirection: "asc",
      sortOptions: [
        {
          value: "full_name",
          text: "Partner Name"
        },
        {
          value: "company_name",
          text: "Business Name"
        },
        { value: "created_at", text: "Created At" }
      ],
      timeoutId: null,
      partnerType: "all",
      filterStatus: "all",
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      view: "table",
      showApprovalModal: false,
      partnerId: null,
      agencies: [],
      guides: [],
      loader: false,
      visibleSideBar: false,
      tempPartnerId: null,
      showPartnerHistory: false
    };
  },
  watch: {},
  async mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "Partners",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  async created() {
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.currentPage = this.partnerSearchCriteria.currentPage;
    this.query = this.partnerSearchCriteria.query;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
    this.agencies = await this.getPartnersOptions();
  },
  methods: {
    getValue(value) {
      if (typeof value === "string") {
        return value.trim();
      } else {
        return value;
      }
    },
    addElementInQuery(query, key, value) {
      let parseValue = this.getValue(value);
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, parseValue);
      } else {
        searchParams.append(key, parseValue);
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        this.get(true, this.limit, this.currentPage, this.query);
      }
    },
    previousPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    nextPaginations(page) {
      this.get(true, this.limit, page, this.query);
    },
    changePage(page) {
      this.get(true, this.limit, page, this.query);
    },
    async deletePartner(partnerId) {
      let { value } = await Swal.fire({
        title: "Delete Partner",
        text: "Are you sure do you want to delete this Partner?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deletePartnerById(partnerId);
      }
    },
    async deletePartnerById(partnerId) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.deletePartnersById(
          partnerId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.limit, 1, this.query);
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "Partner cannot be deleted since it is currently assigned to a reservation.",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },

    async deleteMany() {
      let { value } = await Swal.fire({
        title: "Delete Partners",
        text: "Are you sure do you want to delete the selected Partners?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyPartners(this.selectedRows);
      }
    },
    async deleteManyPartners(partners = []) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.deleteManyPartnersById(
          { partners: partners },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.limit, 1, this.query);
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              partners.length > 1
                ? "Partners cannot be deleted since they are currently assigned to one or many reservations."
                : "Partner cannot be deleted since it is currently assigned to a reservation.",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(partners = []) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.exportPartners(
          { partners: partners },
          this.query,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `partners-${moment().format("DD-MM-YYYY")}.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.setLoad(false);
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    get(loader, limit, page, query) {
      this.setPartnerSearchCriteria({
        currentPage: page,
        query: query,
        limit: limit,
        status: true
      });
      this.getPartners({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
    },
    subscribe(event) {
      var channel = this.pusher.subscribe("rhombuss");
      channel.bind(event, data => {
        if (ROLE_HIERARCHY.includes(this.sesion.role)) {
          if (data.type === "admin") {
            this.get("init", this.pagination);
            this.showNotify(data.action);
          }
        } else {
          let owner = this.getOwner(this.sesion);
          if (data.owner === owner) {
            this.get("init", this.pagination);
            this.showNotify(data.action);
          }
        }
      });
    },
    getOwner(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    showNotify(action) {
      if (action === "deleted") {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Partner has been Deleted",
          icon: "flaticon-check-3"
        });
      } else if (action === "created") {
        this.$notify({
          type: "success",
          title: "Success!",
          message: "The Partner has been created",
          icon: "flaticon-check-3"
        });
      }
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        if (value) {
          this.query = this.addElementInQuery(this.query, "search", value);
          this.get(true, this.limit, 1, this.query);
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          this.get(true, this.limit, 1, this.query);
        }
      }, 500);
    },
    typeSearch(type) {
      this.partnerType = type;
      if (type === "all") {
        this.query = this.deleteItemInQuery(this.query, ["type"]);
        this.get(true, this.limit, 1, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "type", type);
        this.get(true, this.limit, 1, this.query);
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    viewCard() {
      if (this.cardview === true) {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    async sendEmailToConfirmAccount(partnerId, email, type) {
      if (type !== "guest") {
        let { value } = await Swal.fire({
          title: "Account Confirmation Email",
          html:
            "Are you sure you want to <strong>Send</strong> an account confirmation email?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendEmailToConfirmAccountByPartnerId(partnerId, email);
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The email couldn't be sent, check the Partner data and try again",
          icon: "flaticon-remove"
        });
      }
    },
    async sendEmailToConfirmAccountByPartnerId(partnerId, email) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.sendEmailToConfirmAccount(
          partnerId,
          email,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been sent",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The email couldn't be sent, check the Partner data and try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async sendEmailToRecoverPassword(partnerId, email, type) {
      if (type !== "guest") {
        let { value } = await Swal.fire({
          title: "Password Recovery Email",
          html:
            "Are you sure you want to <strong>Send</strong> the password recovery email?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",

          onClose: () => {
            setTimeout(() => {}, 1500);
          }
        });
        if (value) {
          await this.sendEmailToRecoverPasswordByPartnerId(partnerId, email);
        }
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Guest users are not allowed to login",
          icon: "flaticon-warning-1"
        });
      }
    },
    async sendEmailToRecoverPasswordByPartnerId(partnerId, email) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.sendEmailToRecoverPassword(
          partnerId,
          email,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The email has been sent",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The email couldn't be sent, check the Partner data and try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";
      this.partnerType = searchCriteria.has("type")
        ? searchCriteria.get("type")
        : "all";
    },
    isInPartnerModule(modules = []) {
      if (!(modules.indexOf("partners") > -1)) {
        this.setPartnerSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    filteredTab() {
      if (this.filterStatus == "all") {
        this.query = this.deleteItemInQuery(this.query, ["approve"]);
        this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "approve", true);
        this.get(true, this.limit, 1, this.query);
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    openModalApproval(partnerId) {
      this.partnerId = partnerId;
      this.showApprovalModal = true;
    },
    closeApprovalModal(status) {
      this.showApprovalModal = status;
    },
    async onPartnerApproved(status) {
      if (status) {
        this.get(true, this.limit, this.currentPage, this.query);
        this.agencies = await this.getPartnersOptions();
      }
    },
    async getPartnersOptions() {
      try {
        let { data } = await PartnersAPI.getPartnersOptions(this.sesion.token);
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "PARTNERS");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    openPartnerHistoryModal(rateId) {
      this.tempPartnerId = rateId;
      this.showPartnerHistory = !this.showPartnerHistory;
    },
    closePartnerHistoryModal() {
      this.showPartnerHistory = false;
      this.tempPartnerId = null;
    },
    getCommercialTerms(type) {
      if (type === "commission") {
        return "Commission";
      } else {
        return "Net Price";
      }
    },
    ...mapActions(["getPartners", "getLimit"]),
    ...mapMutations([
      "setLoad",
      "setSigOut",
      "setItemsBread",
      "setPartnerSearchCriteria"
    ])
  },
  destroyed() {
    if (this.pusher !== null) {
      this.pusher.disconnect();
    }
    clearTimeout(this.timeoutId);
  },
  computed: {
    items: function() {
      try {
        return this.partners.docs ? this.partners.docs : [];
      } catch (error) {
        return [];
      }
    },
    approval: function() {
      try {
        return this.partners.metadata ? this.partners.metadata.approval : 0;
      } catch (error) {
        return 0;
      }
    },
    ...mapGetters([
      "partners",
      "sesion",
      "userRole",
      "load",
      "sigout",
      "paginationLimit",
      "partnerSearchCriteria"
    ]),
    canUserDelete() {
      return isUserAuthorized("PARTNERS", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("PARTNERS", this.userRole, "CREATE");
    },
    canUserUpdate() {
      return isUserAuthorized("PARTNERS", this.userRole, "UPDATE");
    },
    canUserRead() {
      return isUserAuthorized("PARTNERS", this.userRole, "READ");
    },
    canUserResendEmail() {
      return isUserAuthorized("PARTNERS", this.userRole, "RESEND_EMAIL");
    },
    canUserExport() {
      return isUserAuthorized("PARTNERS", this.userRole, "EXPORT");
    }
  },
  filters: {
    typeUser: function(type) {
      if (type === "travel_agency") {
        return "Travel Agency";
      } else {
        return "Travel Agent";
      }
    },
    formatGender: function(type) {
      if (type === "male") {
        return "Male";
      } else {
        return "Female";
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.isInPartnerModule(to.meta.modules);
    next();
  }
};
</script>
